
// import React, { useState } from "react";
// import { FaUserCircle, FaSearch, FaChevronDown } from "react-icons/fa";
// // Importing PiListBold to match the premium Sidebar style
// import { PiListBold } from "react-icons/pi";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../contexts/AuthContext";
// import "./Header.css";

// function Header({ searchQuery, setSearchQuery, setIsMobileMenuOpen }) {
//   const { currentUser } = useAuth();
//   const navigate = useNavigate();
//   const [showProfileDropdown, setShowProfileDropdown] = useState(false);

//   return (
//     <header className="main-header">
//       {/* Left Section: Menu Toggle (Mobile) + Search */}
//       <div className="header-left">
//         <div className="header-left-content">
//           {/* Mobile Menu Toggle - Only visible on tablet/mobile */}
//           <button 
//             className="mobile-menu-toggle"
//             onClick={() => setIsMobileMenuOpen(true)}
//             aria-label="Open Menu"
//           >
//             <PiListBold />
//           </button>

//           <div className="header-search">
//             <FaSearch className="search-icon" />
//             <input
//               type="text"
//               placeholder="Search"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>
//       </div>

//       {/* Right Section: User Profile (Desktop Only) */}
//       <div className="header-right desktop-only">
//         <div
//           className="user-profile"
//           onClick={(e) => {
//             e.stopPropagation();
//             setShowProfileDropdown(!showProfileDropdown);
//           }}
//         >
//           <div className="user-avatar">
//             <FaUserCircle />
//           </div>
//           <div className="user-details">
//             <span className="user-name">{currentUser?.name || "User"}</span>
//             <span className="user-email">{currentUser?.email}</span>
//           </div>
//           <FaChevronDown
//             className={`dropdown-icon ${
//               showProfileDropdown ? "rotated" : ""
//             }`}
//           />
//           {showProfileDropdown && (
//             <div className="profile-dropdown">
//               <div
//                 className="dropdown-item"
//                 onClick={() => navigate("/profile")}
//               >
//                 Profile
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// }

// export default Header;

import React, { useState } from "react";
import { FaUserCircle, FaSearch, FaChevronDown } from "react-icons/fa";
import { PiListBold } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./Header.css";

function Header({ searchQuery, setSearchQuery, setIsMobileMenuOpen }) {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  return (
    <header className="main-header">
      {/* Left Section: Menu Toggle (Mobile) + Search */}
      <div className="header-left">
        <div className="header-left-content">
          {/* Mobile Menu Toggle - Triggers the Sidebar */}
          <button 
            className="mobile-menu-toggle"
            onClick={(e) => {
              e.stopPropagation(); // Prevent bubbling
              setIsMobileMenuOpen(true);
            }}
            aria-label="Open Menu"
          >
            <PiListBold />
          </button>

          <div className="header-search">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Right Section: User Profile (Desktop Only) */}
      <div className="header-right desktop-only">
        <div
          className="user-profile"
          onClick={(e) => {
            e.stopPropagation();
            setShowProfileDropdown(!showProfileDropdown);
          }}
        >
          <div className="user-avatar">
            <FaUserCircle />
          </div>
          <div className="user-details">
            <span className="user-name">{currentUser?.name || "User"}</span>
            <span className="user-email">{currentUser?.email}</span>
          </div>
          <FaChevronDown
            className={`dropdown-icon ${
              showProfileDropdown ? "rotated" : ""
            }`}
          />
          {showProfileDropdown && (
            <div className="profile-dropdown">
              <div
                className="dropdown-item"
                onClick={() => navigate("/profile")}
              >
                Profile
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;